module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "all-users-page test-class"
  }, [(_vm.downloadInProcess) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All Tasks")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
    staticClass: "to-do active",
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_vm._v("Tasks")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(+_vm.statusbar.published + +_vm.statusbar.archived + +_vm.statusbar.draft) + " resources")]), _vm._v(" "), _c('ul', {
    staticClass: "data-list-statuses data-list-statusbar__block"
  }, [_c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.published) + " published")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.archived) + " archived")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.draft) + " draft")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add",
    attrs: {
      "to": {
        name: 'add-todo'
      },
      "tabindex": "-1"
    }
  }, [_vm._v("Add new Task")])], 1), _vm._v(" "), (this.editedArticles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.tableExport(_vm.csvData)
      }
    }
  }, [_vm._v("Export all Tasks")]) : _vm._e(), _vm._v(" "), (this.articles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.csvExport()
      }
    }
  }, [_vm._v("Export Task/Resource documents")]) : _vm._e(), _vm._v(" "), (_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedArticles.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "articles-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 1
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in TTDs..."
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "column-type-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getContentTypeForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getContentTypeForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'table-head-select',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getContentTypeForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-topics-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getTagsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTagsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getTagsForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-categories-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getChaptersForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getChaptersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getChaptersForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.chapter),
      callback: function($$v) {
        _vm.chapter = $$v
      },
      expression: "chapter"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-companies-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 6,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(6)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 6
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 6),
      expression: "filerTableHead.selectedCeil === 6"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-6",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getCompaniesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.companies),
      callback: function($$v) {
        _vm.companies = $$v
      },
      expression: "companies"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-industries-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 8,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getIndustriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(7)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getIndustriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 7
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 7),
      expression: "filerTableHead.selectedCeil === 7"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-7",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getIndustriesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.industries),
      callback: function($$v) {
        _vm.industries = $$v
      },
      expression: "industries"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('edited', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && this.articleOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && !this.articleOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 10,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 9,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    staticStyle: {
      "max-width": "120px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(9)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 9
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 9),
      expression: "filerTableHead.selectedCeil === 9"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-9",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }],
      "multiple": true
    },
    model: {
      value: (_vm.onBoarding),
      callback: function($$v) {
        _vm.onBoarding = $$v
      },
      expression: "onBoarding"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 11,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 10,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(10)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 10
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 10),
      expression: "filerTableHead.selectedCeil === 10"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-10",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getStatusesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedArticles), function(article, i) {
    return (i < _vm.offset) ? _c('tr', {
      on: {
        "click": function($event) {
          return _vm.editArticle(article.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-center cellpadding"
    }, [_c('label', {
      attrs: {
        "for": article.id
      }
    }, [_vm._v(_vm._s(article.id))])]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.content_type.type))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.tags.length ? article.tags[0].name : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.chapter ? article.chapter.name : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.companies), function(company) {
      return [_vm._v("\n                " + _vm._s(company.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.industries), function(industry) {
      return [_vm._v("\n                " + _vm._s(industry.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(_vm.convertDate(article.updated_at, '.')))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.on_boarding ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('span', {
      staticClass: "status",
      class: {
        'status--archived': article.status === 2, 'status--published': article.status === 1, 'status--draft': article.status === 0
      }
    }, [_vm._v(_vm._s(_vm.getStatus(article.status)))])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "dataDownload"
    }
  }, [_vm._v("download")]), _vm._v(" "), (this.offset <= this.editedArticles.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(8), _vm._v("Load more\n          ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Task category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Industry specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Last Edited")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Onboarding task")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1693a118","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/todo/TodoList.vue
// module id = 948
// module chunks = 0